import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
import { computed, onMounted, reactive } from "vue";
export default {
  __name: 'PrintedItem',
  props: {
    asset: {
      type: Object,
      default: () => {
        return {};
      }
    },
    tags: {
      type: Array,
      default: () => {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: () => {
        return Boolean(false);
      }
    }
  },
  setup(__props) {
    const props = __props;
    const data = reactive({
      assetModel: {},
      rules: {
        types: [{
          required: true,
          message: "请选择印刷品类",
          trigger: "blur"
        }],
        dateRange: [{
          required: true,
          message: "请选择投放日期",
          trigger: "blur"
        }],
        desc: [{
          required: false,
          message: "请需求描述",
          trigger: "blur"
        }]
      }
    });
    onMounted(() => [data.assetModel = props.asset]);
    const imgUrl = computed(() => {
      if (data.assetModel && data.assetModel.srcInnUrl) {
        return data.assetModel.srcInnUrl + '_s';
      }
      return null;
    });
    const previewImgUrl = computed(() => {
      if (data.assetModel && data.assetModel.srcInnUrl) {
        return [data.assetModel.srcInnUrl];
      }
      return [];
    });
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createBlock(_component_el_row, {
        gutter: 24
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 4
        }, {
          default: _withCtx(() => [_createVNode(_component_el_image, {
            class: "asset-img",
            src: imgUrl.value,
            "preview-src-list": previewImgUrl.value
          }, null, 8, ["src", "preview-src-list"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form, {
            model: data.assetModel,
            rules: data.rules
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "印刷品品类",
              prop: "types"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_checkbox_group, {
                disabled: __props.disabled === true,
                modelValue: data.assetModel.types,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.assetModel.types = $event)
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tags, (item, index) => {
                  return _openBlock(), _createBlock(_component_el_checkbox, {
                    key: index,
                    label: item.name,
                    name: item.name
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
                    _: 2
                  }, 1032, ["label", "name"]);
                }), 128))]),
                _: 1
              }, 8, ["disabled", "modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "投放日期",
              prop: "dateRange"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_row, null, {
                default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                  disabled: __props.disabled === true,
                  modelValue: data.assetModel.dateRange,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => data.assetModel.dateRange = $event),
                  type: "daterange",
                  "start-placeholder": "开始时间",
                  "end-placeholder": "结束时间",
                  "value-format": "YYYY-MM-DD"
                }, null, 8, ["disabled", "modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "需求描述",
              prop: "desc"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                disabled: __props.disabled === true,
                modelValue: data.assetModel.desc,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => data.assetModel.desc = $event),
                type: "textarea"
              }, null, 8, ["disabled", "modelValue"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["model", "rules"])]),
          _: 1
        })]),
        _: 1
      });
    };
  }
};